import { useEffect, useState } from "react";

const useBookingPassengers = (
    isHotelInternational,
    isFlightInternational,
    selectedIntFlight,
    flightPassengers,
    intFlightPassengers,
    hotelInformation,
    selectedHotel,
    selectedRooms,
    hotelPassengers,
) => {
    const [updatedFlightPassengers, setUpdatedFligthPassengers] = useState(null);
    const [updatedHotelPassengers, setUpdatedHotelPassengers] = useState(null);

    const isInternational = isHotelInternational && isFlightInternational;

    const formatFlightPr = passenger => ({
        birthday: passenger.birthdate,
        gender: passenger.gender.id,
        type: passenger.passenger_type === "ADL" ? "adt" : passenger.passenger_type,
        first_name: passenger.english_first_name,
        middle_name: "",
        last_name: passenger.english_last_name,
        title: passenger.gender.id === 1 ? "MR" : "MRS",
        passport_country: passenger?.passport_country?.parto_iata || null,
        passport_exp_date: passenger?.passport_exp_date || null,
        passport_issue_date: null,
        passport_number: passenger?.passport_no || null,
        national_code: passenger.nationality?.id === 1 ? passenger.national_code : null,
        nationality: passenger.nationality.parto_iata,
    });

    const formatFlightCh118 = passenger => {
        return {
            first_name: passenger.english_first_name,
            last_name: passenger.english_last_name,
            gender: passenger?.gender?.id,
            type: passenger.passenger_type || passenger.type ,
            nationality: passenger.nationality?.id,
            nationality_code: passenger.nationality.iata,
            ...(passenger.nationality?.id !== 1 && {
                passport_exp_date: passenger?.passport_exp_date,
                passport_issue_date: null,
                passport_number: passenger?.passport_no,
            }),
            ...(passenger.nationality?.id === 1 && {
                national_code: passenger?.national_code,
            }),
            birthday: passenger.birthdate,
        };
    };

    const formatFlightDefault = passenger => ({
        passenger_type: passenger?.passenger_type,
        first_name: passenger?.first_name,
        last_name: passenger?.last_name,
        first_name_en: passenger?.english_first_name,
        last_name_en: passenger?.english_last_name,
        phone_number: passenger?.phone_number,
        national_code: passenger?.national_code ? passenger?.national_code : null,
        passport_number: passenger?.passport_no ? passenger?.passport_no : null,
        country: passenger?.nationality.id,
        gender: passenger?.gender?.id === 1 ? "MALE" : "FEMALE",
        birthday: passenger?.birthdate,
        email: passenger?.email,
    });

    useEffect(() => {
        if (!!flightPassengers || !!intFlightPassengers) {
            const map = {
                pr: isFlightInternational ? intFlightPassengers.passengers.map(formatFlightPr) : flightPassengers.passengers.map(formatFlightPr),
                ch118: isFlightInternational
                    ? intFlightPassengers.passengers.map(formatFlightCh118)
                    : flightPassengers.passengers.map(formatFlightCh118),
                zm:!!flightPassengers&& flightPassengers.passengers.map(formatFlightDefault),
                rs:!!flightPassengers&& flightPassengers.passengers.map(formatFlightDefault),
            };
            setUpdatedFligthPassengers(map);
        }

        if (!!hotelPassengers) {
            if (selectedHotel.tag === "pr") {
                const hotel = {
                    fare_source_code: selectedRooms.fare_source_code,
                    hotel_id: selectedRooms.hotel_id,
                    check_in: hotelInformation?.checkIn,
                    check_out: hotelInformation?.checkOut,
                    policy: selectedRooms.policy,
                    payment_deadline: selectedRooms.payment_deadline,
                    fare: selectedRooms.fare,
                    non_refundable: selectedRooms.non_refundable,
                    passengers: hotelPassengers.rooms.map(room => {
                        return room.passengers.map(passenger => ({
                            first_name: passenger.english_first_name,
                            last_name: passenger.english_last_name,
                            type: passenger.type,
                            title: passenger.title,
                            gender: passenger.gender?.id,
                            national_id: passenger.national_id,
                            age: passenger.type === "chd" ? passenger.age?.id : null,
                        }));
                    }),
                };
                setUpdatedHotelPassengers(hotel);
            } else {
                const hotel = hotelPassengers.passengers.map(passenger => {
                    return {
                        id: passenger?.id,
                        rate_plan_id: passenger?.rate_plan_id,
                        adult: passenger?.roomsCount?.adult,
                        children: passenger?.children,
                        first_name: passenger?.first_name,
                        last_name: passenger?.last_name,
                        phone_number: passenger?.phone_number,
                        email: passenger?.email,
                        national_code: passenger?.national_code ? passenger?.national_code : null,
                        passport_number: passenger?.passport_no ? passenger?.passport_no : null,
                        country: passenger?.nationality.id,
                    };
                });
                setUpdatedHotelPassengers(hotel);
            }
        }
    }, []);

    return { updatedFlightPassengers, updatedHotelPassengers };
};

export default useBookingPassengers;
